<!-- daterange-picker.component.html -->
<button type="button" class="daterange-trigger" (click)="toggleOpen()">
    <i class="fa fa-clock-o" aria-hidden="true"></i>
    <span class="daterange-trigger-label" *ngIf="value?.isRelative()">{{ value.labelKey() | translate }}</span>
    <span class="daterange-trigger-label" *ngIf="value && !value.isRelative()">{{ value.dateFrom | datehournotz }}
        &rarr; {{ value.dateTo | datehournotz }}</span>
    <i class="fa fa-caret-down" aria-hidden="true"></i>
</button>

<ng-template #panelTemplate>
    <div class="daterange-panel">
        <div class="daterange-option" *ngFor="let token of tokens" [class.selected]="isTokenSelected(token)"
            (click)="selectToken(token)">
            {{ 'DATERANGE.' + token | translate }}
        </div>
        <ng-container *ngIf="showAdvancedPanels">
            <div class="daterange-option-separator"></div>
            <div class="daterange-option" [class.selected]="showCustomPanel" (click)="openCustomPanel()">
                {{ 'DATERANGE.STARTANDENDTIMES' | translate }}
            </div>
            <div class="daterange-option" [class.selected]="showAroundPanel" (click)="openAroundPanel()">
                {{ 'DATERANGE.AROUNDATIME' | translate }}
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #subpanelTemplate>
    <div class="daterange-subpanel" *ngIf="showCustomPanel">
        <datehour-picker [(ngModel)]="customFrom" placeholder="{{'LOADLOG.DATEFROM' | translate}}"
            name="daterangeCustomFrom" [showLocaleObserver]="false"></datehour-picker>
        <datehour-picker [(ngModel)]="customTo" placeholder="{{'LOADLOG.DATETO' | translate}}"
            name="daterangeCustomTo" [showLocaleObserver]="false" [min]="customFrom"
            [from]="customFrom"></datehour-picker>
        <div class="daterange-panel-actions">
            <button type="button" class="daterange-apply" (click)="applyCustomPanel()">{{ 'GENERAL.APPLY' |
                translate }}</button>
        </div>
    </div>
    <div class="daterange-subpanel" *ngIf="showAroundPanel">
        <datehour-picker [(ngModel)]="anchorValue" placeholder="{{'DATERANGE.AROUNDATIME' | translate}}"
            name="daterangeAnchor" [showLocaleObserver]="false"></datehour-picker>
        <select class="daterange-duration-select" [(ngModel)]="aroundDurationMs" name="daterangeDuration">
            <option *ngFor="let d of aroundDurations" [value]="d.totalMs">{{ d.labelKey | translate }}</option>
        </select>
        <div class="daterange-panel-actions">
            <button type="button" class="daterange-apply" (click)="applyAroundPanel()">{{ 'GENERAL.APPLY' |
                translate }}</button>
        </div>
    </div>
</ng-template>
